import { FC } from 'react';

import { IconContainer } from '../IconContainer';
import { IconProps } from '../types';

export const MapStroke48: FC<IconProps> = ({
  size = 48,
  color = 'currentColor',
  className,
  style,
  svgClassName,
  svgStyle,
  ariaLabel,
  onClick,
}) => {
  return (
    <IconContainer
      size={size}
      className={className}
      style={style}
      ariaLabel={ariaLabel}
      onClick={onClick}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={svgClassName}
        style={svgStyle}
      >
        <path fillRule="evenodd" clipRule="evenodd" d="M9.3335 13.3365C9.3335 11.2845 11.5532 10.002 13.3306 11.026L18.6665 14.0963L26.6704 11.9537C28.3744 11.4977 30.1938 11.7345 31.7231 12.6158L36.6626 15.4605C37.9026 16.1752 38.6665 17.4967 38.6665 18.9273V34.6646C38.6662 36.7164 36.4466 37.9991 34.6694 36.9752L29.3335 33.9029V33.9059L21.3296 36.0494C19.6244 36.5054 17.8071 36.2684 16.2778 35.3873L11.3374 32.5416C10.0961 31.8269 9.3335 30.5054 9.3335 29.0748V13.3365ZM30.4673 31.9391L36.4019 35.3551V17.9244L30.4673 14.5084V31.9391ZM19.8003 16.1402V34.1109L28.2017 31.86V13.8893L19.8003 16.1402ZM11.6001 30.0787L17.5337 33.4938V16.0631L11.6001 12.6471V30.0787Z" fill={color}/>
      </svg>
    </IconContainer>
  );
};
